import { Button, Form, Input, Select } from 'antd';
import { useTeams } from './TeamStore';

function Add() {
    let {addTeam} = useTeams()
    return (
        <Form layout='vertical' onFinish={(v)=>{addTeam(v)}}>
            <Form.Item name={'name'} label="To'liq ism sharif" rules={[{ required: true, message: 'Please input your name!' }]}>
                <Input />
            </Form.Item>
            <Form.Item name={'role_id'} label="Mansabi" rules={[{ required: true, message: 'Please input your role!' }]}>
                <Select
                    options={[
                        {
                            label: 'Admin',
                            value: 1
                        },
                        {
                            label: 'Buxgalter',
                            value: 2
                        },
                        {
                            label: 'Sotuvchi',
                            value: 3
                        },
                        {
                            label: 'Sklad',
                            value: 4
                        },
                    ]}
                />
            </Form.Item>
            <Form.Item name={'email'} label="Email yoki login" rules={[{ required: true, message: 'Please input your email!' }]}>
                <Input />
            </Form.Item>
            <Form.Item name={'password'} label="Parol" rules={[{ required: true, message: 'Please input your password!' }]}>
                <Input type="password" />
            </Form.Item>
            <Form.Item>
                <Button type="primary" htmlType="submit">Qo'shish</Button>
            </Form.Item>
        </Form>
    );
}
export default Add;